import { selectPermissions } from "Redux/Role/slice";
import { generalData as sidebarItems } from "Shared/Constants/sidebar";
import { MODULES, PERMISSIONS } from "Shared/Types/permissions";
import { isRouteActive } from "Shared/Utils/routes";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
export const usePermissionsRedirect = () => {
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const location = useLocation();

  useEffect(() => {
    if (permissions) {
      const sections: any = [];
      sidebarItems.forEach((item) => {
        sections.push(...item.subMenu);
        item.subMenu.forEach((subitem) => {
          sections.push(...subitem.subMenu);
        });
      });
      const currentSection = sections.find((item: any) => {
        return isRouteActive(location.pathname, item.url, item.subMenu || []);
      });
      if (!currentSection) return;
      if (currentSection.modules) {
        if (
          currentSection.modules.every(
            (module: MODULES) => !permissions.modules.has(module)
          )
        ) {
          navigate(permissions.default_route);
        }
      }
      if (currentSection.permissions) {
        if (
          currentSection.permissions.every(
            (permission: PERMISSIONS) =>
              !permissions.available_permissions.has(permission)
          )
        ) {
          navigate(permissions.default_route);
        }
      }
    }
  }, [permissions, location]);
};
